import { Action } from '@ngrx/store'
import * as ExternalDashboardsSettingsTypes from './external-dashboard-settings.types'

export class FetchExternalDashboardsSettingsRequest implements Action {
  readonly type =
    ExternalDashboardsSettingsTypes.FETCH_EXTERNAL_DASHBOARDS_SETTINGS_REQUEST
  constructor() {}
}

export class FetchExternalDashboardsSettingsSuccess implements Action {
  readonly type =
    ExternalDashboardsSettingsTypes.FETCH_EXTERNAL_DASHBOARDS_SETTINGS_SUCCESS
  constructor(public payload: any) {}
}

export class FetchExternalDashboardsSettingsFailure implements Action {
  readonly type =
    ExternalDashboardsSettingsTypes.FETCH_EXTERNAL_DASHBOARDS_SETTINGS_FAILURE
  constructor(public payload: any) {}
}

export class UpdateExternalDashboardsSettingsRequest implements Action {
  readonly type =
    ExternalDashboardsSettingsTypes.UPDATE_EXTERNAL_DASHBOARDS_SETTINGS_REQUEST
  constructor(public payload: any) {}
}

export class UpdateExternalDashboardsSettingsSuccess implements Action {
  readonly type =
    ExternalDashboardsSettingsTypes.UPDATE_EXTERNAL_DASHBOARDS_SETTINGS_SUCCESS
  constructor() {}
}

export class UpdateExternalDashboardsSettingsFailure implements Action {
  readonly type =
    ExternalDashboardsSettingsTypes.UPDATE_EXTERNAL_DASHBOARDS_SETTINGS_FAILURE
  constructor(public payload: any) {}
}

export class UpdateField implements Action {
  readonly type = ExternalDashboardsSettingsTypes.UPDATE_FIELD
  public constructor(
    public field: string,
    public value: any,
    public path: string,
  ) {}
}

export class SetDefaultData implements Action {
  readonly type = ExternalDashboardsSettingsTypes.SET_DEFAULT_DATA
  public constructor(public path: string) {}
}

export type Actions =
  | FetchExternalDashboardsSettingsSuccess
  | FetchExternalDashboardsSettingsFailure
  | FetchExternalDashboardsSettingsRequest
  | UpdateExternalDashboardsSettingsRequest
  | UpdateExternalDashboardsSettingsSuccess
  | UpdateExternalDashboardsSettingsFailure
  | SetDefaultData
  | UpdateField
